import Login from "screens/login";
import SignUp from "screens/signup";
import Home from "screens/home";
import BlankPage from "screens/blank-page";
import AddProduct from "screens/add-product";
import ProductList from "screens/product-list";
import Orders from "screens/orders";
import TeamList from "screens/team";
import ProfilePage from "screens/profile";
import SettingsWebBuilder from "screens/settings-web-builder";
import SettingsCheckoutFees from "screens/settings-checkout-fees";
import ForgotPassword from "screens/forgot-password";
import ResetPassword from "screens/reset-password";
import MetaAds from "screens/meta-ads";
import MetaAdsCampaign from "screens/meta-ads-campaign";
import Help from "screens/help";

export const routes = {
  Login: {
    path: "/login",
    name: "Root",
    element: <Login />,
    isProtected: false,
  },
  Home: {
    path: "/",
    name: "Home",
    element: <Home />,
    isProtected: true,
  },
  Orders: {
    path: "/orders",
    name: "Orders",
    element: <Orders />,
    isProtected: true,
  },
  Changelog: {
    path: "/changelog",
    name: "Changelog",
    element: <BlankPage />,
    isProtected: true,
  },
  AddProduct: {
    path: "/add-product",
    name: "Add Product",
    element: <AddProduct />,
    isProtected: true,
  },
  ProductList: {
    path: "/product-listing",
    name: "Product List",
    element: <ProductList />,
    isProtected: true,
  },
  TeamList: {
    path: "/team",
    name: "Team",
    element: <TeamList />,
    isProtected: true,
  },
  ProfilePage: {
    path: "/user-profile",
    name: "Profile",
    element: <ProfilePage />,
    isProtected: true,
  },
  WebBuilder: {
    path: "/settings/web-builder",
    name: "Web Builder",
    element: <SettingsWebBuilder />,
    isProtected: true,
  },
  CheckoutFees: {
    path: "/settings/checkout-fees",
    name: "Checkout Fees",
    element: <SettingsCheckoutFees />,
    isProtected: true,
  },
  MetaAds: {
    path: "/meta-ads",
    name: "Meta Ads",
    element: <MetaAds />,
    isProtected: true,
  },
  MetaAdsCampaign: {
    path: "/meta-ads/:campaignId",
    name: "Meta Ads Campaign",
    element: <MetaAdsCampaign />,
    isProtected: true,
  },
  Help: {
    path: "/help",
    name: "Help & Support",
    element: <Help />,
    isProtected: true,
  },
  SignUp: {
    path: "/signup",
    name: "Sign Up",
    element: <SignUp />,
    isProtected: false,
  },
  ForgotPassword: {
    path: "/forgot-password",
    name: "Forgot Password",
    element: <ForgotPassword />,
    isProtected: false,
  },
  ResetPassword: {
    path: "/reset-password",
    name: "Reset Password",
    element: <ResetPassword />,
    isProtected: false,
  },
};
